module.exports = __webpack_public_path__ + "static/media/uploadFile.1c5af4ac.svg";